import styled from '@emotion/styled';
import { Link as RouterLink } from 'react-router-dom';

import { focusRing, hoverable } from '../../interaction-states';
import type { GlobalHeaderViewport } from './types';

export const HEADER_HEIGHT = 56;
export const DIVIDER_HEIGHT = 16;
export const LOGO_MARK_WIDTH = 32;
export const LOGO_MARK_HEIGHT = 36;
export const LOGO_FULL_WIDTH = 126;
export const LOGO_FULL_HEIGHT = 32;

export const StyledHeader = styled('header', {
  shouldForwardProp: (prop) => prop !== '$viewport',
})<{ $viewport: GlobalHeaderViewport }>(({ theme, $viewport }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.colors.background.canvas,
  borderBottom: `1px solid ${theme.colors.border.subtle}`,
  zIndex: 1,
  ...($viewport === 'mobile'
    ? {
        minHeight: HEADER_HEIGHT,
        padding: `${theme.spacing[12]}px ${theme.spacing[16]}px`,
      }
    : {
        height: HEADER_HEIGHT,
        padding: `${theme.spacing[12]}px ${theme.spacing[24]}px`,
      }),
}));

export const HeaderLeft = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
  minWidth: 0,
}));

export const HeaderRight = styled('div', {
  shouldForwardProp: (prop) => prop !== '$viewport',
})<{ $viewport: GlobalHeaderViewport }>(({ theme, $viewport }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $viewport === 'mobile' ? theme.spacing[8] : theme.spacing[16],
  marginLeft: 'auto',
  minWidth: 0,
}));

export const HeaderActionsGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[4],
  minWidth: 0,
}));

export const HeaderDivider = styled('div')({
  display: 'flex',
  alignItems: 'center',
  height: DIVIDER_HEIGHT,
});

export const LogoLink = styled(RouterLink)(({ theme }) => ({
  ...hoverable(theme, 'lift'),
  ...focusRing(theme, { inset: false }),
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  color: theme.colors.white[100],
}));
